import { render, staticRenderFns } from "./Zone.vue?vue&type=template&id=4c721ae9&"
import script from "./Zone.vue?vue&type=script&lang=ts&"
export * from "./Zone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports